export default "__VITE_ASSET__moXO7d$K__"